import * as React from "react"
import { bodyW } from "../../pptx-configuration/constants"
import * as CommonUtils from "../../utils"
import * as Conf from "../../../configuration"
import * as CashFlowDomain from "../../../../../domain/sfp/cash-flow-domain"

export default class RecettesReellesTable extends React.Component<Props> {
	private readonly LABEL_CELL_WIDTH: number
	private readonly VALUE_CELL_WIDTH: number

	constructor(props) {
		super(props)

		this.LABEL_CELL_WIDTH = CommonUtils.toInches(3)
		this.VALUE_CELL_WIDTH = (bodyW - this.LABEL_CELL_WIDTH) / Object.keys(this.props.years).length
	}

	render() {
		const tableConf = this.props.tableConfiguration
		const years = this.props.years

		return <table id={this.props.id}>
			<thead>
				<tr>
					<th data-pptx-width={this.LABEL_CELL_WIDTH}
					style={{ ...tableConf.header }}></th>

					{years.map((y, yi) =>
						<th data-pptx-width={this.VALUE_CELL_WIDTH}
						key={yi}
						style={{ ...tableConf.header }}>{y}</th>
					)}
				</tr>
			</thead>

			{this.renderGrossCashFlowTBody()}
		</table>
	}

	private getDisplayedValue(value: any, type?: RowType): React.ReactText {
		const locale = this.props.locale

		if ("duration" === type) {
			return CashFlowDomain.formatDeleveragingYears(value)
		}

		if ("percentage" === type) {
			const formatter = new Intl.NumberFormat(locale, { style: "percent" })
			return formatter.format(value)
		}

		const currency = this.props.currency
		const roundness = this.props.roundness
		return CommonUtils.formatCurrency(locale, currency, value.recettesReellesDefonctionnement, roundness)
	}

	private getRowBaseStyle(): React.CSSProperties {
		return this.props.tableConfiguration.common
	}
	private calculateTotalRow() {
		const rows: TableRow[] = this.props.budgetData
		let total = {}
		this.props.years.map((_y, yearIndex) => {
			let yearlyTotal = 0;
			rows && rows.map((row, index) => {
				yearlyTotal = yearlyTotal + row.data[_y].recettesReellesDefonctionnement
			})
			total[_y] = {'recettesReellesDefonctionnement': yearlyTotal};
		})
		return total
	}
	private renderGrossCashFlowTBody(): React.ReactNode {
		const baseStyle: React.CSSProperties = this.getRowBaseStyle()
		const conf = this.props.tableConfiguration
		const years = this.props.years
		let rows: TableRow[] = this.props.budgetData
		let totalData = this.calculateTotalRow();
		let parentRow = rows.find(obj => {
			return obj.isParent === true
		  })
		  rows = rows.filter(function( obj ) {
			return obj.isParent !== true;
		});
		rows.push({data: totalData, name: 'Total', code: ''})
		return <tbody>
			<tr>
			<td style={{ ...baseStyle }}>{parentRow.name+' '+parentRow.code}</td>
			{years.map((_y, yearIndex) => {
				const value = parentRow.data[_y]
				return <td key={yearIndex} style={{ ...baseStyle, ...conf.numeric }}>
					{this.getDisplayedValue(value, parentRow.type)}
				</td>
			})}
		</tr>
			{rows.map((row, rowIndex) => this.renderRow(row, rowIndex))}
		</tbody>
    }

	private renderRow(row: TableRow, key?: number): React.ReactNode {
		const conf = this.props.tableConfiguration
		const baseStyle: React.CSSProperties = this.getRowBaseStyle()

		return <tr key={key}>
			<td style={{ ...baseStyle }}>{row.name+' '+row.code}</td>
			{this.props.years.map((_y, yearIndex) => {
				const value = row.data[_y]
				return <td key={yearIndex} style={{ ...baseStyle, ...conf.numeric }}>
					{this.getDisplayedValue(value, row.type)}
				</td>
			})}
		</tr>
	}
}

export interface Props {
	currency: string
	debtRefunds: number[]
	deleveragingYears: number[]
	grossCashFlows: number[]
	id: string
	locale: string
	netCashFlows: number[]
	operationExpenses: number[]
	operationReceipts: number[]
	operationResult: number[]
	reimbursedCapitals: number[]
	remainingCapitals: number[]
	roundness: Conf.RoundnessValue
	tableConfiguration: Conf.TableConfiguration
	years: number[],
	budgetData: any
}

interface BaseTableRow {
	data: any
	name: string
	code?: string
	isParent?: boolean
	type?: RowType
}

type RowType = "currency" | "duration" | "percentage"

type TableRow = BaseTableRow



// WEBPACK FOOTER //
// ./src/component/management-report/generator/budgetGenerator/recettes-generator/recettes-table-generator.tsx